import { Link } from 'react-router-dom';
import { useI18n } from '@/i18n/context';
import { getLocaleFromPath } from '@/i18n/routes';
import { Button } from '@/components/ui/button';
import ThemedGreeninLogo from './ThemedGreeninLogo';
import { Linkedin, Instagram, Facebook, Mail, ArrowUpRight, Lock } from 'lucide-react';
import logoSymbol from '@/assets/logo-symbol.svg';
const Footer = () => {
  const { t, routes, locale } = useI18n();

  const mainLinks = [
    { label: t.nav.sobre, to: routes.about },
    { label: t.nav.coaching, to: routes.coaching },
    { label: t.nav.libros, to: routes.resources },
    { label: t.nav.blog, to: routes.blog },
    { label: t.nav.entrevistas, to: routes.interviews },
    { label: t.nav.contacto, to: routes.contact },
  ];

  const moreLinks = [
    { label: t.nav.ecosistema, to: routes.ecosystem },
  ];

  return (
    <footer className="bg-secondary">
      <div className="container-wide pt-20 pb-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 pb-12 border-b border-secondary-foreground/10">
          <div className="max-w-md">
            <img src={logoSymbol} alt="Andres Luna" className="h-10 w-auto mb-3" width="40" height="40" />
            <p className="text-secondary-foreground/60 text-sm leading-relaxed">{t.footer.tagline}</p>
          </div>
          <Button variant="hero" size="lg" asChild>
            <Link to={routes.contact}>{t.common.bookSession}</Link>
          </Button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 pt-12">
          <div>
            <p className="font-heading font-semibold text-xs uppercase tracking-[0.15em] mb-5 text-secondary-foreground/65">{t.footer.navigation}</p>
            <ul className="space-y-3">
              {mainLinks.map((link) => (<li key={link.to}><Link to={link.to} className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200">{link.label}</Link></li>))}
            </ul>
          </div>
          <div>
            <p className="font-heading font-semibold text-xs uppercase tracking-[0.15em] mb-5 text-secondary-foreground/65">{t.footer.more}</p>
            <ul className="space-y-3">
              {moreLinks.map((link) => (<li key={link.to}><Link to={link.to} className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200">{link.label}</Link></li>))}
              <li>
                <a href="https://greeninco.com/" target="_blank" rel="noopener noreferrer" className="group text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200 inline-flex items-center gap-2">
                  <ThemedGreeninLogo variant="symbol" className="h-4 w-4 opacity-60 group-hover:opacity-90 transition-opacity" alt="" />
                  <span>Company</span>
                  <ArrowUpRight size={12} />
                </a>
              </li>
              <li>
                <a href="https://www.greenin.org/" target="_blank" rel="noopener noreferrer" className="group text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200 inline-flex items-center gap-2">
                  <ThemedGreeninLogo variant="symbol" className="h-4 w-4 opacity-60 group-hover:opacity-90 transition-opacity" alt="" />
                  <span>Impact</span>
                  <ArrowUpRight size={12} />
                </a>
              </li>
              <li>
                <a href="https://www.greenincoach.com" target="_blank" rel="noopener noreferrer" className="group text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200 inline-flex items-center gap-2">
                  <ThemedGreeninLogo variant="symbol" className="h-4 w-4 opacity-60 group-hover:opacity-90 transition-opacity" alt="" />
                  <span>Coach</span>
                  <ArrowUpRight size={12} />
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-heading font-semibold text-xs uppercase tracking-[0.15em] mb-5 text-secondary-foreground/65">{t.footer.contact}</p>
            <ul className="space-y-3">
              <li><a href="https://www.linkedin.com/in/andresluna82/" target="_blank" rel="noopener noreferrer" className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200 inline-flex items-center gap-2"><Linkedin size={14} />LinkedIn</a></li>
              <li><a href="https://www.instagram.com/andreslunaa.co" target="_blank" rel="noopener noreferrer" className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200 inline-flex items-center gap-2"><Instagram size={14} />Instagram</a></li>
              <li><a href="https://www.facebook.com/AndresFLunaA" target="_blank" rel="noopener noreferrer" className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200 inline-flex items-center gap-2"><Facebook size={14} />Facebook</a></li>
              <li><a href="mailto:andres.luna@greeninco.com" className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200 inline-flex items-center gap-2"><Mail size={14} />Email</a></li>
              <li><Link to={routes.contact} className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200">{locale === 'es' ? '¿WhatsApp? Completa el formulario primero' : 'WhatsApp? Fill out the form first'}</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-heading font-semibold text-xs uppercase tracking-[0.15em] mb-5 text-secondary-foreground/65">{t.footer.legal}</p>
            <ul className="space-y-3">
              <li><Link to={locale === 'es' ? '/es/politica-de-privacidad' : '/en/privacy-policy'} className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200">{t.footer.privacy}</Link></li>
              <li><Link to={locale === 'es' ? '/es/terminos-de-servicio' : '/en/terms-of-service'} className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200">{t.footer.terms}</Link></li>
              <li><Link to={locale === 'es' ? '/es/politica-de-pagos' : '/en/payment-policy'} className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200">{locale === 'es' ? 'Pagos y reembolsos' : 'Payments & refunds'}</Link></li>
              <li><Link to={locale === 'es' ? '/es/politica-de-cookies' : '/en/cookies-policy'} className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200">Cookies</Link></li>
              <li><Link to={locale === 'es' ? '/es/accesibilidad' : '/en/accessibility'} className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-200">{locale === 'es' ? 'Accesibilidad' : 'Accessibility'}</Link></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-secondary-foreground/8">
        <div className="container-wide py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-foreground/65">© {new Date().getFullYear()} Andres Luna. {t.footer.rights}</p>
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-4">
              <a href="https://www.linkedin.com/in/andresluna82/" target="_blank" rel="noopener noreferrer" className="text-secondary-foreground/35 hover:text-primary transition-colors duration-200" aria-label="LinkedIn"><Linkedin size={16} /></a>
              <a href="https://www.instagram.com/andreslunaa.co" target="_blank" rel="noopener noreferrer" className="text-secondary-foreground/35 hover:text-primary transition-colors duration-200" aria-label="Instagram"><Instagram size={16} /></a>
              <a href="https://www.facebook.com/AndresFLunaA" target="_blank" rel="noopener noreferrer" className="text-secondary-foreground/35 hover:text-primary transition-colors duration-200" aria-label="Facebook"><Facebook size={16} /></a>
            </div>
            <Link 
              to="/login" 
              className="group relative inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-primary/10 to-primary/5 border border-primary/20 hover:border-primary/40 transition-all duration-300 hover:shadow-lg hover:shadow-primary/10 mb-16 sm:mb-0"
            >
              <Lock size={14} className="text-primary group-hover:scale-110 transition-transform duration-300" />
              <span className="text-xs font-semibold text-primary tracking-wide">{t.footer.adminAccess}</span>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
